"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddToBasketButtonAlpha = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const i18nConstants_1 = require("../../../constants/i18nConstants");
const andes_react_1 = require("@yonderland/andes-react");
const andes_icons_1 = require("@yonderland/andes-icons");
const ProductDetailV2Container_1 = require("../../../containers/product/ProductDetailV2Container");
const AddToBasketButtonAlpha = ({ onClick, quantity = 1, isStickyBar, isOneSizeProduct, disabled = false, }) => {
    const { t } = (0, react_i18next_1.useTranslation)(i18nConstants_1.I18N_NAMESPACES.product);
    const isDesktop = (0, andes_react_1.useMediaQueryMatchesOnDesktop)();
    const { ctaRef } = (0, ProductDetailV2Container_1.useProductDetailContext)();
    const hideText = !isDesktop && isStickyBar && !isOneSizeProduct;
    const fullWidth = !isStickyBar || (isStickyBar && isOneSizeProduct);
    const icon = {
        source: andes_icons_1.ShoppingCartIcon,
        size: 'sm',
    };
    const handleClick = () => {
        onClick(quantity);
    };
    return ((0, jsx_runtime_1.jsx)(andes_react_1.ButtonAlpha, { innerRef: !isStickyBar ? ctaRef : undefined, theme: "branded", variant: "primary", state: disabled ? 'disabled' : 'interactive', fullWidth: fullWidth, testId: "add_to_basket", size: "md", onClick: handleClick, text: !hideText && t('product:pdp.cart.addtobasket.btn'), iconRight: hideText ? icon : undefined, iconLeft: !hideText ? icon : undefined }));
};
exports.AddToBasketButtonAlpha = AddToBasketButtonAlpha;
